<template>
	<div
		class="flex h-10 w-full flex-col items-center justify-center bg-offwhite py-2 shadow-lg transition-all dark:bg-offmain"
	>
		<p class="text-md font-medium text-offmaindark dark:text-white">
			TeleFlow &copy; - {{ new Date().getFullYear() }}
		</p>
	</div>
</template>
